import { MasterDataSDK } from 'neko-common';
import { configs } from '../configs';

const sdk = new MasterDataSDK(configs.apiRoot);
export default sdk;
